import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { propOr } from 'ramda';

import {
  ADMIN,
  DOCTOR,
  PATIENT,
  RESEARCHER,
  SUPER_RESEARCHER,
  TECHNICIAN,
  SUPER_TECHNICIAN,
} from 'constants/userRoles';
import { getUserRole } from 'store/selectors/user';

import AdminRoutes from './AdminRoutes';
import DoctorRoutes from './DoctorRoutes';
import PatientRoutes from './PatientRoutes';
import ResearcherRoutes from './ResearcherRoutes';
import TechnicianRoutes from './TechnicianRoutes';

const Routes = {
  [ADMIN]: AdminRoutes,
  [DOCTOR]: DoctorRoutes,
  [PATIENT]: PatientRoutes,
  [RESEARCHER]: ResearcherRoutes,
  [TECHNICIAN]: TechnicianRoutes,
  [SUPER_TECHNICIAN]: TechnicianRoutes,
  [SUPER_RESEARCHER]: ResearcherRoutes,
};

const EmptyComponent = () => null;

const AuthorizedRoutes = ({ role, ...rest }) => {
  const RoutesComponent = propOr(EmptyComponent, role, Routes);
  return <RoutesComponent {...rest} />;
};

AuthorizedRoutes.defaultProps = {
  role: null,
};

AuthorizedRoutes.propTypes = {
  role: PropTypes.string,
};

const mapStateToProps = state => ({
  role: getUserRole(state),
});

export default connect(mapStateToProps)(AuthorizedRoutes);
